export class CadTrainingFacility {
  public id?: number;
  public trainingFacilitiesName?: string | null;
  public specification?: string | null;
  public unit?: string | null;
  public minQuantityReq?: number | null;
  public remark?: string | null;
  public tamMainId?: number | null;
  public tamMain?: any;
  constructor() {}
}